
              import "_sentry-module-metadata-injection-stub";
              import * as OriginalModule from "./app/javascript/application.ts";
              export default OriginalModule.default;
              export * from "./app/javascript/application.ts";